module.exports = __webpack_public_path__ + "img/pumpkin-soup-1600x800.5b0cf3db.jpg";